import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RegexUtilities {
    //  https://github.com/benjamingr/RegExp.escape
    escape(s: string): string {
        return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }
}
